import React from "react";
import CheckIcon from "/Images/cekidot.svg"; // Checklist icon
import DeployImage from "/Images/sectionn1xcrow.svg"; // Gambar deployment
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"; // Ikon panah dari Material UI
import { useMediaQuery } from "@mui/material"; // Import media query hook

const DeploymentSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)"); // Media query for mobile screen

  // Responsive styles based on isMobile
  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row", // Column for mobile, row for desktop
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#E7E4E2",
      padding: isMobile ? "50px 20px" : "100px", // Smaller padding on mobile
      borderRadius: "10px",
      textAlign: isMobile ? "center" : "left",
      gap: "20px",
    },
    paragraph: {
      color: "#6D6D6D",
      fontSize: isMobile ? "0.875rem" : "1rem", // Smaller font on mobile
      lineHeight: "1.6",
      marginBottom: "20px",
      textAlign: "justify", // Justify text
    },
    textContainer: {
      width: isMobile ? "100%" : "50%", // Full width on mobile
      paddingRight: isMobile ? "0" : "20px",
      marginBottom: isMobile ? "20px" : "0", // Bottom spacing on mobile
    },
    imageContainer: {
      width: isMobile ? "100%" : "50%", // Full width on mobile
      display: "flex",
      justifyContent: "center",
      marginBottom: isMobile ? "20px" : "0", // Bottom spacing for image on mobile
    },
    image: {
      width: isMobile ? "80%" : "574px", // Adjust image width for mobile
      maxWidth: isMobile ? "400px" : "574px",
      borderRadius: "10px",
    },
    heading: {
      color: "#2D669B",
      fontSize: isMobile ? "24px" : "32px", // Smaller font on mobile
      fontWeight: "600",
      marginBottom: "20px",
    },
    subheading: {
      color: "#214D73",
      fontSize: isMobile ? "18px" : "1.5rem",
      marginBottom: "10px",
    },
    listItem: {
      display: "flex",
      alignItems: "center",
      marginBottom: "10px",
      color: "#6D6D6D",
      justifyContent: isMobile ? "center" : "flex-start", // Center on mobile
    },
    listIcon: {
      width: isMobile ? "15px" : "20px", // Smaller icon on mobile
      height: isMobile ? "15px" : "20px",
      marginRight: "10px",
    },
    exploreMore: {
      color: "#B0990D",
      fontSize: isMobile ? "0.875rem" : "1rem", // Smaller font on mobile
      textDecoration: "underline",
      display: "flex",
      alignItems: "center",
      justifyContent: isMobile ? "center" : "flex-start", // Center on mobile
      marginTop: "20px",
      cursor: "pointer",
    },
    arrow: {
      marginLeft: "10px", // Space between text and arrow
      backgroundColor: "#2D669B", // Circle color
      borderRadius: "50%",
      padding: "5px",
      color: "#F4E37B", // Arrow color
    },
  };

  return (
    <div style={styles.container}>
      {/* Conditionally render the image above text content on mobile */}
      {isMobile && (
        <div style={styles.imageContainer}>
          <img src={DeployImage} alt="Deployment" style={styles.image} />
        </div>
      )}
      <div style={styles.textContainer}>
        <h2 style={styles.heading}>
          Your Xcrow Service <br />
          For Secure Crypto Escrow Transaction
        </h2>
        <p style={styles.paragraph}>
          Xcrow is an online crypto escrow transaction method that involves buyers, sellers, and a
          third party, with the third party responsible for managing the
          accounts receivable to ensure the transaction process is secure.
          Xcrow services safeguard the privacy of both parties, protecting them
          from fraud. Cognitos' Xcrow service enhances this protection by
          holding the buyer's funds in Xcrow account until the seller fulfills
          their obligations, ensuring a safe and transparent transaction for all
          parties involved.
        </p>

        {/* Explore More Link */}
        <div style={styles.exploreMore}>
          Explore more
          <ArrowForwardIcon style={styles.arrow} />
        </div>
      </div>
      {/* Render the image on the side for desktop */}
      {!isMobile && (
        <div style={styles.imageContainer}>
          <img src={DeployImage} alt="Deployment" style={styles.image} />
        </div>
      )}
    </div>
  );
};

export default DeploymentSection;
